import React, { useEffect, useRef } from 'react';
import { ChevronDown } from '@olxbr/ds-icons';
import * as Styles from './styles';
import { sendClickEvent } from '../../utils';
import Link from '../../../Link';
import Avatar from '../../../Avatar';
import Skeleton from '../../../Skeleton';
export function Profile({ openSubMenu, onLogin, setOpenSubMenu, accountInfo, children }) {
    const { isLogged, isLoading, profilePicture, userName } = accountInfo;
    const profileButtonRef = useRef(null);
    useEffect(() => {
        if (isLogged) {
            onLogin();
        }
    }, [isLogged, onLogin]);
    if (isLoading) {
        return React.createElement(Skeleton, { dsParentName: "Header", className: "profile-skeleton", width: "135px", height: "40px" });
    }
    return (React.createElement(Styles.Item, null,
        !isLogged ? (React.createElement(Link, { dsParentName: "Header", href: "https://conta.olx.com.br/anuncios", className: "profile-link", "data-header-keyboard-navigation": "true", onClick: () => sendClickEvent('login', 'sub_menu') }, "Entrar")) : (React.createElement("button", { "data-ds-component": "DS-Profile-Button", "aria-haspopup": "true", "aria-expanded": openSubMenu, className: "profile-link", "data-header-keyboard-navigation": "true", onClick: () => setOpenSubMenu((prev) => !prev), ref: profileButtonRef },
            React.createElement(Avatar, { dsParentName: "Header", size: "32px", src: profilePicture }),
            React.createElement(Styles.NickName, null, userName.split(' ')[0]),
            React.createElement(ChevronDown, { size: "16" }))),
        children));
}
Profile.displayName = 'Profile';
